// import React from 'react';
// import CountUp from 'react-countup';

// //import 
// import ProfileStrength from '../Jobick/Statistics/ProfileStrength';
// import NetworkSection from '../Jobick/Statistics/NetworkSection';
// import VacanciesStatsTab from '../Jobick/Statistics/VacanciesStatsTab';
// import CanvasChartTab from '../Jobick/Home/CanvasChartTab';
// import FeaturedCompanies from '../Jobick/Home/FeaturedCompanies';
// import PostPage from './Task';
// import JobApplication from '../Jobs/JobApplication';

// import PowerCanvasChartTab from '../Jobick/Home/PowerCanvasChartTab';

// const Power = () => {
//     return (
//         <>
//             <div className="row">
//                 <div className="col-xl-12 mt-4">
//                     <div className="row">
//                         <div className="col-xl-12">
//                             <div className="card">
//                                 <div className="card-body">
//                                     <div className="d-flex justify-content-between align-items-center shapreter-row" style={{ padding: '20px 0 0 0' }}>
//                                         <div className="text-center" style={{ padding: '0 25px 0 0', borderRight: '1px solid #ddd' }}>
//                                             <div className="static-icon mb-2">
//                                                 <i className="fas fa-solar-panel" style={{ fontSize: "30px", color: "#ff6b6b" }}></i>
//                                             </div>
//                                             <h3 className="count mb-0">4</h3>
//                                             <span className="fs-14">Sites</span>
//                                         </div>
//                                         <div className="text-center" style={{ padding: '0 45px 0 0', borderRight: '1px solid #ddd' }}>
//                                             <div className="static-icon mb-2">
//                                                 <i className="fas fa-toggle-on" style={{ fontSize: "30px", color: "#ff6b6b" }}></i>
//                                             </div>
//                                             <h3 className="count mb-0">4</h3>
//                                             <span className="fs-14">ON</span>
//                                         </div>
//                                         <div className="text-center" style={{ padding: '0 45px 0 0', borderRight: '1px solid #ddd' }}>
//                                             <div className="static-icon mb-2">
//                                                 <i className="fas fa-toggle-off" style={{ fontSize: "30px", color: "#ff6b6b" }}></i>
//                                             </div>
//                                             <h3 className="count mb-0">0</h3>
//                                             <span className="fs-14">OFF</span>
//                                         </div>
//                                         <div className="text-center" style={{ padding: '0 45px 0 0', borderRight: '1px solid #ddd' }}>
//                                             <div className="static-icon mb-2">
//                                                 <i className="fas fa-sun" style={{ fontSize: "30px", color: "#ff6b6b" }}></i>
//                                             </div>
//                                             <h3 className="count mb-0">1918</h3>
//                                             <span className="fs-14">Capacity kWp</span>
//                                         </div>
//                                         <div className="text-center" style={{ padding: '0 45px 0 0', borderRight: '1px solid #ddd' }}>
//                                             <div className="static-icon mb-2">
//                                                 <i className="fas fa-wifi" style={{ fontSize: "30px", color: "#ff6b6b" }}></i>
//                                             </div>
//                                             <h3 className="count mb-0">51/51</h3>
//                                             <span className="fs-14">Units</span>
//                                         </div>
//                                         <div className="text-center" style={{ padding: '0 45px 0 0', borderRight: '1px solid #ddd' }}>
//                                             <div className="static-icon mb-2">
//                                                 <i className="fas fa-bolt" style={{ fontSize: "30px", color: "#ff6b6b" }}></i>
//                                             </div>
//                                             <h3 className="count mb-0">47/47</h3>
//                                             <span className="fs-14">Inverter</span>
//                                         </div>
//                                         <div className="text-center" style={{ padding: '0 45px 0 0', borderRight: '1px solid #ddd' }}>
//                                             <div className="static-icon mb-2">
//                                                 <i className="fas fa-cogs" style={{ fontSize: "30px", color: "#ff6b6b" }}></i>
//                                             </div>
//                                             <h3 className="count mb-0">4/4</h3>
//                                             <span className="fs-14">WMS</span>
//                                         </div>
//                                         <div className="text-center" style={{ padding: '0 15px' }}>
//                                             <div className="static-icon mb-2">
//                                                 <i className="fas fa-leaf" style={{ fontSize: "30px", color: "#ff6b6b" }}></i>
//                                             </div>
//                                             <h3 className="count mb-0">1352285.60</h3>
//                                             <span className="fs-14">CO2 Saved Kg/kWh</span>
//                                         </div>
//                                     </div>
//                                 </div>
//                             </div>
//                         </div>


//                         {/* <div className="col-xl-12">
//                             <PostPage />
//                         </div> */}
//                         {/* <div className="col-xl-6">
// 							<NetworkSection />
// 						</div>
// 						<div className="col-xl-12">
// 							<VacanciesStatsTab />
// 						</div> */}
// 						<div className="col-xl-6">
// 							<div className="row">
// 								<div className="col-xl-12">
// 									<CanvasChartTab />
// 								</div>
// 							</div>
// 						</div>
// 						<div className="col-xl-6">
// 							<div className="row">
// 								<div className="col-xl-12">
// 									<PowerCanvasChartTab />
// 								</div>
// 							</div>
// 						</div>
//                         <div className="col-xl-12">
//                             <div className="row">
//                                 <div className="col-xl-6">
//                                     <JobApplication />
//                                 </div>
//                             </div>
//                         </div>
//                     </div>
//                 </div>
//             </div>
//         </>
//     )
// }
// export default Power;






// import React from 'react';
// import CountUp from 'react-countup';
// import {
//     Row,
//     Col,
//     Card,
//     Dropdown,
//     DropdownButton,
//     ButtonGroup,
//     SplitButton,
//   } from "react-bootstrap";
// //import 
// import ProfileStrength from '../Jobick/Statistics/ProfileStrength';
// import NetworkSection from '../Jobick/Statistics/NetworkSection';
// import VacanciesStatsTab from '../Jobick/Statistics/VacanciesStatsTab';
// import CanvasChartTab from '../Jobick/Home/CanvasChartTab';
// import FeaturedCompanies from '../Jobick/Home/FeaturedCompanies';
// import PostPage from './Task';
// import JobApplication from '../Jobs/JobApplication';

// import PowerCanvasChartTab from '../Jobick/Home/PowerCanvasChartTab';
// import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet';
// import 'leaflet/dist/leaflet.css';
// const position = [20.5937, 78.9629]; // Center on India


// const Power = () => {
//     return (
//         <>
//             <div className="row">
//                 <div className="col-xl-12 mt-4">
//                     <div className="row">
//                         <div className="col-xl-12">
//                             <div className="card">
//                                 <div className="card-body">
//                                     <div className="d-flex justify-content-between align-items-center shapreter-row" style={{ padding: '20px 0 0 0' }}>
//                                         <div className="text-center" style={{ padding: '0 25px 0 0', borderRight: '1px solid #ddd' }}>
//                                             <div className="static-icon mb-2">
//                                                 <i className="fas fa-solar-panel" style={{ fontSize: "30px", color: "#ff6b6b" }}></i>
//                                             </div>
//                                             <h3 className="count mb-0">4</h3>
//                                             <span className="fs-14">Sites</span>
//                                         </div>
//                                         <div className="text-center" style={{ padding: '0 45px 0 0', borderRight: '1px solid #ddd' }}>
//                                             <div className="static-icon mb-2">
//                                                 <i className="fas fa-toggle-on" style={{ fontSize: "30px", color: "#ff6b6b" }}></i>
//                                             </div>
//                                             <h3 className="count mb-0">4</h3>
//                                             <span className="fs-14">ON</span>
//                                         </div>
//                                         <div className="text-center" style={{ padding: '0 45px 0 0', borderRight: '1px solid #ddd' }}>
//                                             <div className="static-icon mb-2">
//                                                 <i className="fas fa-toggle-off" style={{ fontSize: "30px", color: "#ff6b6b" }}></i>
//                                             </div>
//                                             <h3 className="count mb-0">0</h3>
//                                             <span className="fs-14">OFF</span>
//                                         </div>
//                                         <div className="text-center" style={{ padding: '0 45px 0 0', borderRight: '1px solid #ddd' }}>
//                                             <div className="static-icon mb-2">
//                                                 <i className="fas fa-sun" style={{ fontSize: "30px", color: "#ff6b6b" }}></i>
//                                             </div>
//                                             <h3 className="count mb-0">1918</h3>
//                                             <span className="fs-14">Capacity kWp</span>
//                                         </div>
//                                         <div className="text-center" style={{ padding: '0 45px 0 0', borderRight: '1px solid #ddd' }}>
//                                             <div className="static-icon mb-2">
//                                                 <i className="fas fa-wifi" style={{ fontSize: "30px", color: "#ff6b6b" }}></i>
//                                             </div>
//                                             <h3 className="count mb-0">51/51</h3>
//                                             <span className="fs-14">Units</span>
//                                         </div>
//                                         <div className="text-center" style={{ padding: '0 45px 0 0', borderRight: '1px solid #ddd' }}>
//                                             <div className="static-icon mb-2">
//                                                 <i className="fas fa-bolt" style={{ fontSize: "30px", color: "#ff6b6b" }}></i>
//                                             </div>
//                                             <h3 className="count mb-0">47/47</h3>
//                                             <span className="fs-14">Inverter</span>
//                                         </div>
//                                         <div className="text-center" style={{ padding: '0 45px 0 0', borderRight: '1px solid #ddd' }}>
//                                             <div className="static-icon mb-2">
//                                                 <i className="fas fa-cogs" style={{ fontSize: "30px", color: "#ff6b6b" }}></i>
//                                             </div>
//                                             <h3 className="count mb-0">4/4</h3>
//                                             <span className="fs-14">WMS</span>
//                                         </div>
//                                         <div className="text-center" style={{ padding: '0 15px' }}>
//                                             <div className="static-icon mb-2">
//                                                 <i className="fas fa-leaf" style={{ fontSize: "30px", color: "#ff6b6b" }}></i>
//                                             </div>
//                                             <h3 className="count mb-0">1352285.6</h3>
//                                             <span className="fs-14">CO2 Saved Kg/kWh</span>
//                                         </div>
//                                     </div>
//                                 </div>
//                             </div>
//                         </div>
//                         <Card.Body>
//               <div className="basic-dropdown">
//                 <Dropdown>
//                   <Dropdown.Toggle variant="primary">
//                     Dropdown button
//                   </Dropdown.Toggle>
//                   <Dropdown.Menu>
//                     <Dropdown.Item href="#">Link 1</Dropdown.Item>
//                     <Dropdown.Item href="#">Link 2</Dropdown.Item>
//                     <Dropdown.Item href="#">Link 3</Dropdown.Item>
//                   </Dropdown.Menu>
//                 </Dropdown>
//               </div>
//             </Card.Body>


//                         {/* <div className="col-xl-12">
//                             <PostPage />
//                         </div> */}
//                         {/* <div className="col-xl-6">
// 							<NetworkSection />
// 						</div>
// 						<div className="col-xl-12">
// 							<VacanciesStatsTab />
// 						</div> */}
// 						<div className="col-xl-6">
// 							<div className="row">
// 								<div className="col-xl-12">
// 									<CanvasChartTab />
// 								</div>
// 							</div>
// 						</div>
// 						<div className="col-xl-6">
// 							<div className="row">
// 								<div className="col-xl-12">
// 									<PowerCanvasChartTab />
// 								</div>
// 							</div>
// 						</div>
//                         {/* <div className="col-xl-12">
//                             <div className="row">
//                                 <div className="col-xl-6">
//                                     <JobApplication />
//                                 </div>
//                             </div>
//                         </div> */}
//                         <div className="col-xl-12">
//                             <div className="row">
//                                 {/* <div className="col-xl-6">
//                                     <MapContainer center={position} zoom={5} style={{ height: "400px", width: "100%" }}>
//                                         <TileLayer
//                                             url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
//                                             attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
//                                         />
//                                         <Marker position={position}>
//                                             <Popup>
//                                                 India is the center of the map.
//                                             </Popup>
//                                         </Marker>
//                                     </MapContainer>
//                                 </div> */}
//                                 {/* <div className="col-xl-12">
//                                     <JobApplication />
//                                 </div> */}
//                             </div>
//                         </div>
//                     </div>
//                 </div>
//             </div>
//         </>
//     )
// }
// export default Power;


// import React, { useState } from 'react';
// import CountUp from 'react-countup';
// import {
//     Row,
//     Col,
//     Card,
//     Dropdown,
// } from "react-bootstrap";
// import CanvasChartTab from '../Jobick/Home/CanvasChartTab';
// import PowerCanvasChartTab from '../Jobick/Home/PowerCanvasChartTab';

// // Random data for different dropdown options
// const randomData = {
//     Site1: {
//         sites: 4,
//         on: 4,
//         off: 0,
//         capacityKwp: 1918,
//         units: '51/51',
//         inverter: '47/47',
//         wms: '4/4',
//         co2Saved: 1352285.6,
//     },
//     Site2: {
//         sites: 6,
//         on: 5,
//         off: 1,
//         capacityKwp: 2100,
//         units: '53/55',
//         inverter: '46/47',
//         wms: '3/4',
//         co2Saved: 1420000.0,
//     },
//     Site3: {
//         sites: 3,
//         on: 3,
//         off: 0,
//         capacityKwp: 1800,
//         units: '48/48',
//         inverter: '45/45',
//         wms: '4/4',
//         co2Saved: 1250000.8,
//     }
// };

// const Power = () => {
//     // State for dropdown selection and corresponding data
//     const [selectedOption, setSelectedOption] = useState('Site1');
//     const [dropdownLabel, setDropdownLabel] = useState('Choose Site');

//     const handleSelect = (key) => {
//         setSelectedOption(key);
//         setDropdownLabel(`${key}`);
//     };

//     const data = randomData[selectedOption];

//     return (
//         <>
//             <div className="row mt-n5">
//                 <div className="col-xl-12">
//                     <div className="row">
//                         <Card.Body>
//                             <div className="basic-dropdown">
//                                 <Dropdown onSelect={handleSelect}>
//                                     <Dropdown.Toggle variant="primary">
//                                         {dropdownLabel}
//                                     </Dropdown.Toggle>
//                                     <Dropdown.Menu>
//                                         <Dropdown.Item eventKey="Site1">Site 1</Dropdown.Item>
//                                         <Dropdown.Item eventKey="Site2">Site 2</Dropdown.Item>
//                                         <Dropdown.Item eventKey="Site3">Site 3</Dropdown.Item>
//                                     </Dropdown.Menu>
//                                 </Dropdown>
//                             </div>
//                         </Card.Body>
//                         <div className="col-xl-12">
//                             <div className="card">
//                                 <div className="card-body">
//                                     <div className="d-flex justify-content-between align-items-center shapreter-row" style={{ padding: '20px 0 0 0' }}>
                                        
//                                         <div className="text-center" style={{ padding: '0 45px 0 0', borderRight: '1px solid #ddd' }}>
//                                             <div className="static-icon mb-2">
//                                                 <i className="fas fa-sun" style={{ fontSize: "30px", color: "#ff6b6b" }}></i>
//                                             </div>
//                                             <h3 className="count mb-0">{data.capacityKwp}</h3>
//                                             <span className="fs-14">Capacity kWp</span>
//                                         </div>
//                                         <div className="text-center" style={{ padding: '0 45px 0 0', borderRight: '1px solid #ddd' }}>
//                                             <div className="static-icon mb-2">
//                                                 <i className="fas fa-wifi" style={{ fontSize: "30px", color: "#ff6b6b" }}></i>
//                                             </div>
//                                             <h3 className="count mb-0">{data.units}</h3>
//                                             <span className="fs-14">Units</span>
//                                         </div>
//                                         <div className="text-center" style={{ padding: '0 45px 0 0', borderRight: '1px solid #ddd' }}>
//                                             <div className="static-icon mb-2">
//                                                 <i className="fas fa-bolt" style={{ fontSize: "30px", color: "#ff6b6b" }}></i>
//                                             </div>
//                                             <h3 className="count mb-0">{data.inverter}</h3>
//                                             <span className="fs-14">Inverter</span>
//                                         </div>
//                                         <div className="text-center" style={{ padding: '0 45px 0 0', borderRight: '1px solid #ddd' }}>
//                                             <div className="static-icon mb-2">
//                                                 <i className="fas fa-cogs" style={{ fontSize: "30px", color: "#ff6b6b" }}></i>
//                                             </div>
//                                             <h3 className="count mb-0">{data.wms}</h3>
//                                             <span className="fs-14">WMS</span>
//                                         </div>
//                                         <div className="text-center" style={{ padding: '0 15px' }}>
//                                             <div className="static-icon mb-2">
//                                                 <i className="fas fa-leaf" style={{ fontSize: "30px", color: "#ff6b6b" }}></i>
//                                             </div>
//                                             <h3 className="count mb-0">{data.co2Saved}</h3>
//                                             <span className="fs-14">CO2 Saved Kg/kWh</span>
//                                         </div>
//                                     </div>
//                                 </div>
//                             </div>
//                         </div>


//                         <div className="col-xl-12">
//                             <div className="row">
//                                 <div className="col-xl-12">
//                                     <CanvasChartTab />
//                                 </div>
//                             </div>
//                         </div>
//                         {/* <div className="col-xl-6">
//                             <div className="row">
//                                 <div className="col-xl-12">
//                                     <PowerCanvasChartTab />
//                                 </div>
//                             </div>
//                         </div> */}
//                     </div>
//                 </div>
//             </div>
//         </>
//     )
// }
// export default Power;





// import React, { useState } from 'react';
// import {
//     Row,
//     Col,
//     Card,
//     Dropdown,
// } from "react-bootstrap";
// import CanvasChartTab from '../Jobick/Home/CanvasChartTab';

// // Mapping sites to RTU IDs
// const siteMapping = {
//     Site1: "RTU1928",
//     Site2: "RTU1933",
//     Site3: "RTU1934"
// };

// // Random data for different dropdown options
// const randomData = {
//     Site1: {
//         // sites: 4,
//         // on: 4,
//         // off: 0,
//         capacityKwp: 660,
//         LifetimeGenerationMWh: '68.42',
//         inverter: '6/6',
//         GenerationToday: '2837.96',
//         co2Saved: 2554.164,
//     },
//     Site2: {
//         // sites: 6,
//         // on: 5,
//         // off: 1,
//         capacityKwp: 99,
//         LifetimeGenerationMWh: '56.79',
//         inverter: '1/1',
//         GenerationToday: '475.54',
//         co2Saved: 427.98600000000005,
//     },
//     Site3: {
//         // sites: 3,
//         // on: 3,
//         // off: 0,
//         capacityKwp: 100.1,
//         LifetimeGenerationMWh: '464.27',
//         inverter: '2/2',
//         GenerationToday: '399.30',
//         co2Saved: 359.37,
//     }
// };

// const Power = () => {
//     const [selectedOption, setSelectedOption] = useState('Site1');
//     const [dropdownLabel, setDropdownLabel] = useState('Site 1');

//     const handleSelect = (key) => {
//         setSelectedOption(key);
//         setDropdownLabel(`${key}`);
//     };

//     const data = randomData[selectedOption];
//     const selectedRTU = siteMapping[selectedOption]; // Get RTU ID based on selected site

//     return (
//         <>
//             <div className="row mt-5">
//                 <div className="col-xl-12">
//                     <div className="row mt-10">
//                         <Card.Body>
//                             <div className="basic-dropdown">
//                                 <Dropdown onSelect={handleSelect}>
//                                     <Dropdown.Toggle variant="primary">
//                                         {dropdownLabel}
//                                     </Dropdown.Toggle>
//                                     <Dropdown.Menu>
//                                         <Dropdown.Item eventKey="Site1">Site 1</Dropdown.Item>
//                                         <Dropdown.Item eventKey="Site2">Site 2</Dropdown.Item>
//                                         <Dropdown.Item eventKey="Site3">Site 3</Dropdown.Item>
//                                     </Dropdown.Menu>
//                                 </Dropdown>
//                             </div>
//                         </Card.Body>
//                         <div className="col-xl-12">
//                             <div className="card">
//                                 <div className="card-body">
//                                     <div className="d-flex justify-content-between align-items-center shapreter-row" style={{ padding: '20px 0 0 0' }}>
                                        
//                                         <div className="text-center" style={{ padding: '0 45px 0 0', borderRight: '1px solid #ddd' }}>
//                                             <div className="static-icon mb-2">
//                                                 <i className="fas fa-sun" style={{ fontSize: "30px", color: "#ff6b6b" }}></i>
//                                             </div>
//                                             <h3 className="count mb-0">{data.capacityKwp}</h3>
//                                             <span className="fs-14">Capacity kWp</span>
//                                         </div>
//                                         <div className="text-center" style={{ padding: '0 45px 0 0', borderRight: '1px solid #ddd' }}>
//                                             <div className="static-icon mb-2">
//                                                 <i className="fas fa-wifi" style={{ fontSize: "30px", color: "#ff6b6b" }}></i>
//                                             </div>
//                                             <h3 className="count mb-0">{data.LifetimeGenerationMWh}</h3>
//                                             <span className="fs-14">Lifetime Generation (MWh)</span>
//                                         </div>
//                                         <div className="text-center" style={{ padding: '0 45px 0 0', borderRight: '1px solid #ddd' }}>
//                                             <div className="static-icon mb-2">
//                                                 <i className="fas fa-bolt" style={{ fontSize: "30px", color: "#ff6b6b" }}></i>
//                                             </div>
//                                             <h3 className="count mb-0">{data.inverter}</h3>
//                                             <span className="fs-14">Inverter</span>
//                                         </div>
//                                         <div className="text-center" style={{ padding: '0 45px 0 0', borderRight: '1px solid #ddd' }}>
//                                             <div className="static-icon mb-2">
//                                                 <i className="fas fa-cogs" style={{ fontSize: "30px", color: "#ff6b6b" }}></i>
//                                             </div>
//                                             <h3 className="count mb-0">{data.GenerationToday}</h3>
//                                             <span className="fs-14">Today Generation</span>
//                                         </div>
//                                         <div className="text-center" style={{ padding: '0 15px' }}>
//                                             <div className="static-icon mb-2">
//                                                 <i className="fas fa-leaf" style={{ fontSize: "30px", color: "#ff6b6b" }}></i>
//                                             </div>
//                                             <h3 className="count mb-0">{data.co2Saved}</h3>
//                                             <span className="fs-14">CO2 Saved Kg/kWh</span>
//                                         </div>
//                                     </div>
//                                 </div>
//                             </div>
//                         </div>

//                         {/* Pass the selected RTU ID to CanvasChartTab */}
//                         <div className="col-xl-12">
//                             <div className="row">
//                                 <div className="col-xl-12">
//                                     <CanvasChartTab rtuId={selectedRTU} />
//                                 </div>
//                             </div>
//                         </div>
//                     </div>
//                 </div>
//             </div>
//         </>
//     )
// }

// export default Power;





// import React, { useState, useEffect } from 'react';
// import {
//     Card,
//     Dropdown,
// } from "react-bootstrap";
// import CanvasChartTab from '../Jobick/Home/CanvasChartTab';

// const AUTH_API_URL = "https://portal.intellotechsolutions.co.in:5000/api/intello/authenticate";

// // Mapping sites to RTU IDs
// const siteMapping = {
//     Site1: "RTU1928",
//     Site2: "RTU1933",
//     Site3: "RTU1934"
// };

// // Static data for dropdown options
// const staticData = {
//     Site1: { capacityKwp: 660, LifetimeGenerationMWh: '68.42', inverter: '6/6', co2Saved: 2554.164 },
//     Site2: { capacityKwp: 99, LifetimeGenerationMWh: '56.79', inverter: '1/1', co2Saved: 427.99 },
//     Site3: { capacityKwp: 100.1, LifetimeGenerationMWh: '464.27', inverter: '2/2', co2Saved: 359.37 }
// };

// const Power = () => {
//     const [selectedOption, setSelectedOption] = useState('Site1');
//     const [dropdownLabel, setDropdownLabel] = useState('Site 1');
//     const [todayGeneration, setTodayGeneration] = useState('Loading...');
//     const [authToken, setAuthToken] = useState(null);

//     const selectedRTU = siteMapping[selectedOption];

//     // Authenticate user to get token
//     const authenticateUser = async () => {
//         try {
//             const response = await fetch(AUTH_API_URL, {
//                 method: "POST",
//                 headers: { "Content-Type": "application/json" },
//                 body: JSON.stringify({
//                     username: "prateek@enfros.co.in",
//                     password: "9032961c4a5757c8b460c2ecdecbdabc337950cd7b3b1a0fb2592a4b130630ca",
//                 }),
//             });
//             const data = await response.json();
//             if (data.token) setAuthToken(data.token);
//             else console.error("Authentication failed");
//         } catch (error) {
//             console.error("Error during authentication:", error);
//         }
//     };

//     // Fetch today's generation data using token
//     const fetchTodayGeneration = async () => {
//         if (!authToken) return;

//         const today = new Date();
//         const formattedToday = today.toISOString().split("T")[0];

//         const apiUrl = `https://portal.intellotechsolutions.co.in:5000/api/intello/rtu/v1/data?fromDate=${formattedToday}&mode=Monthly&resultType=site&rtuid=${selectedRTU}`;

//         try {
//             const response = await fetch(apiUrl, {
//                 method: "GET",
//                 headers: {
//                     Authorization: `Bearer ${authToken}`,
//                     "Content-Type": "application/json"
//                 },
//             });
//             const data = await response.json();

//             const record = data.find(item =>
//                 parseInt(item.day, 10) === today.getDate() && parseInt(item.month, 10) === (today.getMonth() + 1)
//             );

//             setTodayGeneration(record ? record.generation : 'N/A');
//         } catch (error) {
//             console.error("Error fetching generation data:", error);
//             setTodayGeneration('Error');
//         }
//     };

//     useEffect(() => {
//         authenticateUser(); // Authenticate on component mount
//     }, []);

//     useEffect(() => {
//         if (authToken) {
//             fetchTodayGeneration(); // Fetch data after token is available
//         }
//     }, [authToken, selectedOption, selectedRTU]);

//     const data = { ...staticData[selectedOption], GenerationToday: todayGeneration };

//     const handleSelect = (key) => {
//         setSelectedOption(key);
//         setDropdownLabel(`Site ${key.replace('Site', '')}`);
//     };

//     return (
//         <>
//             <div className="row mt-n5">
//                 <div className="col-xl-12">
//                     <div className="row">
//                         <Card.Body>
//                             <div className="basic-dropdown">
//                                 <Dropdown onSelect={handleSelect}>
//                                     <Dropdown.Toggle variant="primary">
//                                         {dropdownLabel}
//                                     </Dropdown.Toggle>
//                                     <Dropdown.Menu>
//                                         <Dropdown.Item eventKey="Site1">Site 1</Dropdown.Item>
//                                         <Dropdown.Item eventKey="Site2">Site 2</Dropdown.Item>
//                                         <Dropdown.Item eventKey="Site3">Site 3</Dropdown.Item>
//                                     </Dropdown.Menu>
//                                 </Dropdown>
//                             </div>
//                         </Card.Body>

//                         <div className="col-xl-12">
//                             <div className="card">
//                                 <div className="card-body">
//                                     <div className="d-flex justify-content-between align-items-center" style={{ padding: '20px 0 0 0' }}>
//                                         <div className="text-center" style={{ padding: '0 45px', borderRight: '1px solid #ddd' }}>
//                                             <i className="fas fa-sun mb-2" style={{ fontSize: "30px", color: "#ff6b6b" }}></i>
//                                             <h3>{data.capacityKwp}</h3>
//                                             <span>Capacity kWp</span>
//                                         </div>
//                                         <div className="text-center" style={{ padding: '0 45px', borderRight: '1px solid #ddd' }}>
//                                             <i className="fas fa-wifi mb-2" style={{ fontSize: "30px", color: "#ff6b6b" }}></i>
//                                             <h3>{data.LifetimeGenerationMWh}</h3>
//                                             <span>Lifetime Generation (MWh)</span>
//                                         </div>
//                                         <div className="text-center" style={{ padding: '0 45px', borderRight: '1px solid #ddd' }}>
//                                             <i className="fas fa-bolt mb-2" style={{ fontSize: "30px", color: "#ff6b6b" }}></i>
//                                             <h3>{data.inverter}</h3>
//                                             <span>Inverter</span>
//                                         </div>
//                                         <div className="text-center" style={{ padding: '0 45px', borderRight: '1px solid #ddd' }}>
//                                             <i className="fas fa-cogs mb-2" style={{ fontSize: "30px", color: "#ff6b6b" }}></i>
//                                             <h3>{data.GenerationToday}</h3>
//                                             <span>Today Generation</span>
//                                         </div>
//                                         <div className="text-center" style={{ padding: '0 15px' }}>
//                                             <i className="fas fa-leaf mb-2" style={{ fontSize: "30px", color: "#ff6b6b" }}></i>
//                                             <h3>{data.co2Saved}</h3>
//                                             <span>CO2 Saved Kg/kWh</span>
//                                         </div>
//                                     </div>
//                                 </div>
//                             </div>
//                         </div>

//                         {/* Pass the selected RTU ID to CanvasChartTab */}
//                         <div className="col-xl-12">
//                             <CanvasChartTab rtuId={selectedRTU} />
//                         </div>
//                     </div>
//                 </div>
//             </div>
//         </>
//     );
// };

// export default Power;



// import React, { useState, useEffect } from 'react';
// import {
//     Card,
//     Dropdown,
// } from "react-bootstrap";
// import CanvasChartTab from '../Jobick/Home/CanvasChartTab';

// const AUTH_API_URL = "https://portal.intellotechsolutions.co.in:5000/api/intello/authenticate";

// // Mapping sites to RTU IDs
// const siteMapping = {
//     Site1: "RTU1928",
//     Site2: "RTU1933",
//     Site3: "RTU1934"
// };

// // Static data for dropdown options
// const staticData = {
//     Site1: { capacityKwp: 660, LifetimeGenerationMWh: '68.42', inverter: '6/6' },
//     Site2: { capacityKwp: 99, LifetimeGenerationMWh: '56.79', inverter: '1/1' },
//     Site3: { capacityKwp: 100.1, LifetimeGenerationMWh: '464.27', inverter: '2/2' }
// };

// const Power = () => {
//     const [selectedOption, setSelectedOption] = useState('Site1');
//     const [dropdownLabel, setDropdownLabel] = useState('Site 1');
//     const [todayGeneration, setTodayGeneration] = useState('Loading...');
//     const [authToken, setAuthToken] = useState(null);

//     const selectedRTU = siteMapping[selectedOption];

//     // Authenticate user to get token
//     const authenticateUser = async () => {
//         try {
//             const response = await fetch(AUTH_API_URL, {
//                 method: "POST",
//                 headers: { "Content-Type": "application/json" },
//                 body: JSON.stringify({
//                     username: "prateek@enfros.co.in",
//                     password: "9032961c4a5757c8b460c2ecdecbdabc337950cd7b3b1a0fb2592a4b130630ca",
//                 }),
//             });
//             const data = await response.json();
//             if (data.token) setAuthToken(data.token);
//             else console.error("Authentication failed");
//         } catch (error) {
//             console.error("Error during authentication:", error);
//         }
//     };

//     // Fetch today's generation data using token
//     const fetchTodayGeneration = async () => {
//         if (!authToken) return;

//         const today = new Date();
//         const formattedToday = today.toISOString().split("T")[0];

//         const apiUrl = `https://portal.intellotechsolutions.co.in:5000/api/intello/rtu/v1/data?fromDate=${formattedToday}&mode=Monthly&resultType=site&rtuid=${selectedRTU}`;

//         try {
//             const response = await fetch(apiUrl, {
//                 method: "GET",
//                 headers: {
//                     Authorization: `Bearer ${authToken}`,
//                     "Content-Type": "application/json"
//                 },
//             });
//             const data = await response.json();

//             const record = data.find(item =>
//                 parseInt(item.day, 10) === today.getDate() && parseInt(item.month, 10) === (today.getMonth() + 1)
//             );

//             setTodayGeneration(record ? record.generation : 'N/A');
//         } catch (error) {
//             console.error("Error fetching generation data:", error);
//             setTodayGeneration('Error');
//         }
//     };

//     useEffect(() => {
//         authenticateUser(); // Authenticate on component mount
//     }, []);

//     useEffect(() => {
//         if (authToken) {
//             fetchTodayGeneration(); // Fetch data after token is available
//         }
//     }, [authToken, selectedOption, selectedRTU]);

//     // Calculate CO₂ Saved = 0.9 * Today Generation (if valid)
//     const co2Saved = !isNaN(parseFloat(todayGeneration)) ? (0.9 * parseFloat(todayGeneration)).toFixed(2) : 'N/A';

//     const data = { ...staticData[selectedOption], GenerationToday: todayGeneration, co2Saved };

//     const handleSelect = (key) => {
//         setSelectedOption(key);
//         setDropdownLabel(`Site ${key.replace('Site', '')}`);
//     };

//     return (
//         <>
//             <div className="row mt-n5">
//                 <div className="col-xl-12">
//                     <div className="row">
//                         <Card.Body>
//                             <div className="basic-dropdown">
//                                 <Dropdown onSelect={handleSelect}>
//                                     <Dropdown.Toggle variant="primary">
//                                         {dropdownLabel}
//                                     </Dropdown.Toggle>
//                                     <Dropdown.Menu>
//                                         <Dropdown.Item eventKey="Site1">Site 1</Dropdown.Item>
//                                         <Dropdown.Item eventKey="Site2">Site 2</Dropdown.Item>
//                                         <Dropdown.Item eventKey="Site3">Site 3</Dropdown.Item>
//                                     </Dropdown.Menu>
//                                 </Dropdown>
//                             </div>
//                         </Card.Body>

//                         <div className="col-xl-12">
//                             <div className="card">
//                                 <div className="card-body">
//                                     <div className="d-flex justify-content-between align-items-center" style={{ padding: '20px 0 0 0' }}>
//                                         <div className="text-center" style={{ padding: '0 45px', borderRight: '1px solid #ddd' }}>
//                                             <i className="fas fa-sun mb-2" style={{ fontSize: "30px", color: "#ff6b6b" }}></i>
//                                             <h3>{data.capacityKwp}</h3>
//                                             <span>Capacity kWp</span>
//                                         </div>
//                                         <div className="text-center" style={{ padding: '0 45px', borderRight: '1px solid #ddd' }}>
//                                             <i className="fas fa-wifi mb-2" style={{ fontSize: "30px", color: "#ff6b6b" }}></i>
//                                             <h3>{data.LifetimeGenerationMWh}</h3>
//                                             <span>Lifetime Generation (MWh)</span>
//                                         </div>
//                                         <div className="text-center" style={{ padding: '0 45px', borderRight: '1px solid #ddd' }}>
//                                             <i className="fas fa-bolt mb-2" style={{ fontSize: "30px", color: "#ff6b6b" }}></i>
//                                             <h3>{data.inverter}</h3>
//                                             <span>Inverter</span>
//                                         </div>
//                                         <div className="text-center" style={{ padding: '0 45px', borderRight: '1px solid #ddd' }}>
//                                             <i className="fas fa-cogs mb-2" style={{ fontSize: "30px", color: "#ff6b6b" }}></i>
//                                             <h3>{data.GenerationToday}</h3>
//                                             <span>Today Generation</span>
//                                         </div>
//                                         <div className="text-center" style={{ padding: '0 15px' }}>
//                                             <i className="fas fa-leaf mb-2" style={{ fontSize: "30px", color: "#ff6b6b" }}></i>
//                                             <h3>{data.co2Saved}</h3>
//                                             <span>CO₂ Saved (Kg/kWh)</span>
//                                         </div>
//                                     </div>
//                                 </div>
//                             </div>
//                         </div>

//                         {/* Pass the selected RTU ID to CanvasChartTab */}
//                         <div className="col-xl-12">
//                             <CanvasChartTab rtuId={selectedRTU} />
//                         </div>
//                     </div>
//                 </div>
//             </div>
//         </>
//     );
// };

// export default Power;




import React, { useState, useEffect } from 'react';
import {
    Card,
    Dropdown,
    Row,
    Col,
    Container
} from "react-bootstrap";
import CanvasChartTab from '../Jobick/Home/CanvasChartTab';

const AUTH_API_URL = "https://portal.intellotechsolutions.co.in:5000/api/intello/authenticate";

// Mapping sites to RTU IDs
const siteMapping = {
    Site1: "RTU1928",
    Site2: "RTU1933",
    Site3: "RTU1934"
};

// Static data for dropdown options
const staticData = {
    Site1: { capacityKwp: 660, LifetimeGenerationMWh: '68.42', inverter: '6/6' },
    Site2: { capacityKwp: 99, LifetimeGenerationMWh: '56.79', inverter: '1/1' },
    Site3: { capacityKwp: 100.1, LifetimeGenerationMWh: '464.27', inverter: '2/2' }
};

const Power = () => {
    const [selectedOption, setSelectedOption] = useState('Site1');
    const [dropdownLabel, setDropdownLabel] = useState('Site 1');
    const [todayGeneration, setTodayGeneration] = useState('Loading...');
    const [authToken, setAuthToken] = useState(null);

    const selectedRTU = siteMapping[selectedOption];

    const authenticateUser = async () => {
        try {
            const response = await fetch(AUTH_API_URL, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                    username: "prateek@enfros.co.in",
                    password: "9032961c4a5757c8b460c2ecdecbdabc337950cd7b3b1a0fb2592a4b130630ca",
                }),
            });
            const data = await response.json();
            if (data.token) setAuthToken(data.token);
            else console.error("Authentication failed");
        } catch (error) {
            console.error("Error during authentication:", error);
        }
    };

    const fetchTodayGeneration = async () => {
        if (!authToken) return;

        const today = new Date();
        const formattedToday = today.toISOString().split("T")[0];

        const apiUrl = `https://portal.intellotechsolutions.co.in:5000/api/intello/rtu/v1/data?fromDate=${formattedToday}&mode=Monthly&resultType=site&rtuid=${selectedRTU}`;

        try {
            const response = await fetch(apiUrl, {
                method: "GET",
                headers: {
                    Authorization: `Bearer ${authToken}`,
                    "Content-Type": "application/json"
                },
            });
            const data = await response.json();

            const record = data.find(item =>
                parseInt(item.day, 10) === today.getDate() && parseInt(item.month, 10) === (today.getMonth() + 1)
            );

            setTodayGeneration(record ? record.generation : 'N/A');
        } catch (error) {
            console.error("Error fetching generation data:", error);
            setTodayGeneration('Error');
        }
    };

    useEffect(() => {
        authenticateUser();
    }, []);

    useEffect(() => {
        if (authToken) {
            fetchTodayGeneration();
        }
    }, [authToken, selectedOption, selectedRTU]);

    const co2Saved = !isNaN(parseFloat(todayGeneration)) ? (0.9 * parseFloat(todayGeneration)).toFixed(2) : 'N/A';
    const data = { ...staticData[selectedOption], GenerationToday: todayGeneration, co2Saved };

    const handleSelect = (key) => {
        setSelectedOption(key);
        setDropdownLabel(`Site ${key.replace('Site', '')}`);
    };

    return (
        <Container fluid className="mt-n4">
            <Card className="mb-4 shadow-sm">
                <Card.Body className="d-flex flex-column flex-md-row justify-content-between align-items-center">
                    <h5 className="mb-2 mb-md-0">Select Site</h5>
                    <Dropdown onSelect={handleSelect}>
                        <Dropdown.Toggle variant="primary">
                            {dropdownLabel}
                        </Dropdown.Toggle>
                        <Dropdown.Menu>
                            <Dropdown.Item eventKey="Site1">Site 1</Dropdown.Item>
                            <Dropdown.Item eventKey="Site2">Site 2</Dropdown.Item>
                            <Dropdown.Item eventKey="Site3">Site 3</Dropdown.Item>
                        </Dropdown.Menu>
                    </Dropdown>
                </Card.Body>
            </Card>

            {/* Evenly distributed cards */}
            <Row className="g-3 justify-content-between">
                {[
                    { icon: "fas fa-sun", value: data.capacityKwp, label: "Capacity kWp" },
                    { icon: "fas fa-wifi", value: data.LifetimeGenerationMWh, label: "Lifetime Generation (MWh)" },
                    { icon: "fas fa-bolt", value: data.inverter, label: "Inverter" },
                    { icon: "fas fa-cogs", value: data.GenerationToday, label: "Today Generation" },
                    { icon: "fas fa-leaf", value: data.co2Saved, label: "CO₂ Saved (Kg/kWh)" }
                ].map((item, index) => (
                    <Col key={index} xs={12} sm={6} md={4} lg={3} xl={2} className="d-flex">
                        <Card className="text-center shadow-sm rounded-lg flex-fill">
                            <Card.Body className="d-flex flex-column justify-content-center">
                                <i className={`${item.icon} mb-2`} style={{ fontSize: "28px", color: "#ff6b6b" }}></i>
                                <h4 className="mb-1">{item.value}</h4>
                                <small className="text-muted">{item.label}</small>
                            </Card.Body>
                        </Card>
                    </Col>
                ))}
            </Row>

            {/* Chart Section */}
            <div className="mt-3" style={{ marginBottom: "15px" }}>
                <Card className="shadow-sm">
                    <Card.Body style={{ height: '500px' }}>
                        <CanvasChartTab rtuId={selectedRTU} />
                    </Card.Body>
                </Card>
            </div>
        </Container>
    );
};

export default Power;
